import React from 'react'

const companiesSettings = () => {
  return (
    <div>companiesSettings</div>
  )
}

export default companiesSettings